export default __webpack_public_path__ + "static/media/RoundedCheckIconGreen.973aae39.svg";